import React from "react"

const ClearIcon = ({
  color = "#CDCDCD",
  innerColor = "white",
}: {
  color?: string
  innerColor?: string
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill={color} />
      <path
        d="M7 12.66L12.66 7"
        stroke={innerColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.66 12.66L7 7"
        stroke={innerColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ClearIcon
